import type { ReactNode } from 'react';
import { useRef } from 'react';

import classNames from 'classnames';

import styles from './CarouselItem.module.css';

import type { CarouselChildProps } from './Carousel';

export interface CarouselItemProps extends CarouselChildProps {
  children: ReactNode;
  className?: string;
}

/**
 * List item for the carousel. Maintains a ref to the root li to be sent to the
 * click handler. This is so the event handler always receives the li element
 * instead of a descendant of the li.
 */
export function CarouselItem(props: CarouselItemProps) {
  const self = useRef<HTMLLIElement>(null);
  const className = classNames(
    styles.container,
    { [styles.fullWidth]: props.fullWidth },
    props.className
  );
  const handleMouseUp = () => {
    if (!self.current) {
      return;
    }
    props.onMouseUp(self.current);
  };
  return (
    <li ref={self} onMouseUp={handleMouseUp} className={className}>
      {props.children}
    </li>
  );
}
